import { createStyles, Theme } from '@material-ui/core/styles';
import { Manrope } from '../../constants/theme';

/**
 *
 * @param {Theme} theme Material Theam.
 * @returns {Theme} Return Material theams.
 */
const Styles = (theme: Theme) =>
	createStyles({
		root: {
			pointerEvents: 'none',
			zIndex: 1000,
			position: 'absolute',
			top: '50%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			left: '50%',
			transform: 'translate(-50%,-50%)',
			background: 'rgba(255,255,255,0.5)',
			width: '100%',
			height: '100%',
			flexDirection: 'column'
		},
		errorTitle: {
			fontFamily: Manrope,
			fontSize: '200px',
			fontWeight: 300,
			color: '#000000',
			[theme.breakpoints.down('sm')]: {
				fontSize: '100px'
			}
		},
		errorMessage: {
			fontFamily: Manrope,
			fontSize: '32px',
			fontWeight: 300,
			color: '#000000',
			lineHeight: '44px',
			textAlign: 'center',
			marginLeft: theme.spacing(2),
			marginRight: theme.spacing(2),
			[theme.breakpoints.down('sm')]: {
				fontSize: '20px',
				lineHeight: '20px'
			}
		}
	});

export default Styles;
